const ErrorMessage = ({ message = 'Something went wrong.', onRetry }) => (
  <div style={{ padding: 32, textAlign: 'center' }}>
    <div style={{ fontSize: 40, marginBottom: 8 }}>⚠️</div>
    <p style={{ color: '#dc2626', fontSize: 14, marginBottom: 12 }}>{message}</p>
    {onRetry && (
      <button
        onClick={onRetry}
        style={{
          background: 'linear-gradient(135deg, #D4AF37, #A67C00)', color: '#fff', border: 'none',
          padding: '10px 20px', borderRadius: 10, fontWeight: 600,
        }}
      >
        Retry
      </button>
    )}
  </div>
);

export default ErrorMessage;